import { isCliAuthPath } from './publicRoutes'

const VISIT_KEY_PREFIX = 'veilstream_cli_login_visit:'
const reported = new Set<string>()

export function cliLoginVisitStorageKey(pathname: string, search = ''): string | null {
  if (!isCliAuthPath(pathname)) return null
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
  const id = params.get('state') || params.get('user_code') || pathname
  return VISIT_KEY_PREFIX + id
}

export function cliLoginVisitPayload(pathname: string, search = ''): { path: string; client_name: string } | null {
  if (!isCliAuthPath(pathname)) return null
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
  return {
    path: pathname,
    client_name: params.get('client_name') ?? '',
  }
}

/** Fire-and-forget Slack ping for a CLI login page view. Deduped per tab + grant. */
export function reportCliLoginVisit(pathWithSearch = `${window.location.pathname}${window.location.search}`): void {
  const qIndex = pathWithSearch.indexOf('?')
  const pathname = qIndex >= 0 ? pathWithSearch.slice(0, qIndex) : pathWithSearch
  const search = qIndex >= 0 ? pathWithSearch.slice(qIndex) : ''
  const key = cliLoginVisitStorageKey(pathname, search)
  const payload = cliLoginVisitPayload(pathname, search)
  if (!key || !payload) return
  if (reported.has(key)) return
  reported.add(key)
  try {
    if (sessionStorage.getItem(key)) return
    sessionStorage.setItem(key, '1')
  } catch {
    /* private mode — in-memory set still dedupes this tab */
  }

  void postCliLoginVisit(payload)
}

async function postCliLoginVisit(payload: { path: string; client_name: string }): Promise<void> {
  const [{ apiUrl }, { getSessionToken }] = await Promise.all([
    import('./apiClient'),
    import('../auth/session'),
  ])
  const headers: Record<string, string> = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
  const token = getSessionToken()
  if (token) headers.Authorization = `Bearer ${token}`

  try {
    await fetch(apiUrl('/api/public/cli-login-visit'), {
      method: 'POST',
      credentials: 'omit',
      headers,
      body: JSON.stringify(payload),
    })
  } catch {
    /* Slack must not block CLI login */
  }
}
